import React from 'react';

function ConfirmDialog({ title, message, confirmText = 'Подтвердить', cancelText = 'Отмена', onConfirm, onCancel, variant = 'primary',
  altText = null, onAlt = null }) {
  // Порядок как во всех окнах: [Отмена] [Подтвердить] — главная справа (UX-аудит 25.10);
  // необратимое (variant="danger": удалить, в архив) — красная. altText — второе действие между ними
  // («Принять без рекламации»)
  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal modal-confirm" style={{ maxWidth: altText ? 640 : 420 }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">{title}</h2>
          <button className="modal-close" onClick={onCancel}>&times;</button>
        </div>
        <div className="modal-body">
          <div style={{ margin: 0, fontSize: 14, color: '#5E6561', lineHeight: 1.5 }}>{message}</div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onCancel}>{cancelText}</button>
          {altText && <button className="btn btn-secondary" onClick={onAlt}>{altText}</button>}
          <button className={variant === 'danger' ? 'btn btn-danger' : 'btn btn-primary'} onClick={onConfirm}>{confirmText}</button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDialog;
